import { makeStyles } from '@alpha/ui-lib/theme';

const useStyles = makeStyles(({ typography }) => ({
  subHeading: {
    fontFamily: typography.fontFamilySecondary,
    fontSize: '16px',
    marginBottom: '18px',
    fontWeight: typography.fontWeightSemiBold,
  },
  subHeading2: {
    fontFamily: typography.fontFamilySecondary,
    fontSize: '12px',
    fontWeight: typography.fontWeightSemiBold,
    marginBottom: '1.5em',
  },
  infoIcon: {
    marginTop: '4px',
    marginLeft: '4px',
    cursor: 'pointer',
  },
  statsContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: '30px 0px 0px 0px',
    height: 'calc(100vh - 140px)',
  },
  remitContainer: {
    padding: '16px 24px 11px 24px',
    border: '1px solid #EAEAEA',
    borderRadius: '10px',
  },
  radioContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  dropdown: {
    '& .MuiSelect-root': {
      backgroundColor: '#f7f7f7',
      height: '53px',
      borderRadius: '5px',
      padding: '0 16px',
      paddingRight: '40px',
      marginBottom: '6px',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    '& .MuiSvgIcon-root': {
      right: '7px',
    },
  },
  detailTable: {
    padding: '10px 20px 0px 20px',
    background: '#f7f7f7',
    borderRadius: '10px',

    '& .MuiTableBody-root tr': {
      borderBottom: '1px solid rgba(112, 112, 112, 0.1)', // Apply border to all rows
    },

    '& .MuiTableBody-root tr:nth-child(5)': {
      borderBottom: 'none', // Remove bottom border for the 5th row
      paddingBottom: '2px', // Custom padding for the 5th row
    },

    '& .MuiTableBody-root tr:last-child': {
      borderBottom: 'none', // Remove bottom border for the last row
    },
  },
  buttonsContainer: {
    display: 'flex',
    gap: '8px',
    justifyContent: 'space-between',
    marginTop: 'auto',
  },
}), { name: 'SettlementsStyles' });

export default useStyles;
